module.exports = __webpack_public_path__ + "img/icon-question-light-blue.70c501de.svg";